import { render, staticRenderFns } from "./standburgexecl.vue?vue&type=template&id=4bb4e452&scoped=true"
import script from "./standburgexecl.vue?vue&type=script&lang=js"
export * from "./standburgexecl.vue?vue&type=script&lang=js"
import style0 from "./standburgexecl.vue?vue&type=style&index=0&id=4bb4e452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4e452",
  null
  
)

export default component.exports